import { RepresentativesWidgetRepository } from '../repositories/representativesWidgetRepository.js';
import { representativeWidget as owlConfig } from '../configs/OwlConfig';

export class RepresentativesWidget {
	constructor() {
		this.repository = new RepresentativesWidgetRepository();
		this.owlConfig = owlConfig;
		this.initState();
		this.initElementList();
		this.addListeners();
		this.updateRegionId();
		this.typingTimeout = '';
		if (window.innerWidth < 768) {
			this.createOwl();
		}
	}

	initState() {
		this.state = {
			cache: {
				key: '',
				data: new Map(),
			},
			regionId: 0,
			lineOfBusinessId: 0,
			searchValue: '',
			owl: null,
		};
	}

	initElementList() {
		this.elementClassList = {
			regionFilterItem: 'js-region-filter-list__item',
			active: 'is-active',
			regionName: 'js-representative-feed__region-name',
			representativeFeedList: 'js-representative-feed__list',
			contactButtons: 'c-representative-feed__list__item__button',
		};

		this.searchInput = document.querySelector("#representative-country-name");

		this.linesOFBusiness = {
			linesOFBusinessFilterItem: 'js-lines-of-business-filter-list__item',
			active: 'is-active',
			linesOFBusinessName: 'js-representative-feed__region-name',
			representativeFeedList: 'js-representative-feed__list',
			contactButtons: 'c-representative-feed__list__item__button',
		}
	}

	addListeners() {
		const regionElements = document.getElementsByClassName(
			this.elementClassList.regionFilterItem
		);
		Array.from(regionElements).forEach((regionElement) => {
			regionElement.addEventListener('click', (event) =>
				this.regionClickHandler(event)
			);
		});

		const linesOFBusinessElements = document.getElementsByClassName(
			this.linesOFBusiness.linesOFBusinessFilterItem
		);

		Array.from(linesOFBusinessElements).forEach((linesOFBusinessElement) => {
			linesOFBusinessElement.addEventListener('click', (event) =>
				this.linesOFBusinessClickHandler(event)
			);
		});

		if(this.searchInput){
			this.searchInput.addEventListener('input', (event) =>
				this.searchClickHandler(event)
			);
		}

		window.addEventListener('resize', (e) => this.windowResizeHandler(e));

		document.body.addEventListener('click', (event) =>
			this.contactButtonClickHandler(event)
		);
	}

	contactButtonClickHandler(event) {
		if (
			event.target &&
			event.target.className === this.elementClassList.contactButtons
		) {
			const clickedContactButton = event.target;
			const buttonRegion =
				clickedContactButton.getAttribute('data-region');
			const contactFormBlock = document.querySelector(
				'.contact-form-block'
			);
			const hsFormCountrySelect = document.querySelector(
				'.hbspt-form .hs-input[name=hsf_country]'
			);
			const nayaxHeader = document.querySelector('.nayax-header');
			const hsFormScrollTop =
				contactFormBlock.getBoundingClientRect().top +
				window.pageYOffset -
				(parseInt(window.getComputedStyle(contactFormBlock).marginTop) +
					nayaxHeader.offsetHeight);

			if (hsFormCountrySelect) {
				hsFormCountrySelect.value = buttonRegion;
				window.scroll({
					left: 0,
					top: hsFormScrollTop,
					behavior: 'smooth',
				});
			}
		}
	}

	regionClickHandler(event) {
		const target = event.currentTarget;
		const activeClassName = this.elementClassList.active;

		if (target.classList.contains(activeClassName)) {
			return;
		}

		const dropdownWrapper = event.target.closest('.nx-dropdown-wrapper');
		if(dropdownWrapper){
			dropdownWrapper.classList.remove("active");
			let regionName = event.target.innerText;
			let dropdownButtonText = dropdownWrapper.querySelector('.nx-dropdown-toggler-text');
			if(dropdownButtonText){
				dropdownButtonText.innerText = regionName;
			}
		}

		const activeElementsSelector = `${this.elementClassList.regionFilterItem} ${activeClassName}`;
		const activeElements = document.getElementsByClassName(
			activeElementsSelector
		);

		Array.from(activeElements).forEach((activeElement) => {
			activeElement.classList.remove(activeClassName);
		});

		target.classList.add(activeClassName);

		this.updateRegionId();

		this.getFilteredData();
	}

	linesOFBusinessClickHandler(event)
	{
		const target = event.currentTarget;
		const activeClassName = this.linesOFBusiness.active;

		if (target.classList.contains(activeClassName)) {
			return;
		}

		const dropdownWrapper = event.target.closest('.nx-dropdown-wrapper');
		if(dropdownWrapper){
			dropdownWrapper.classList.remove("active");
			let linesOFBusinessName = event.target.innerText;
			let dropdownButtonText = dropdownWrapper.querySelector('.nx-dropdown-toggler-text');
			if(dropdownButtonText){
				dropdownButtonText.innerText = linesOFBusinessName;
			}
		}

		const activeElementsSelector = `${this.linesOFBusiness.linesOFBusinessFilterItem} ${activeClassName}`;
		const activeElements = document.getElementsByClassName(
			activeElementsSelector
		);

		Array.from(activeElements).forEach((activeElement) => {
			activeElement.classList.remove(activeClassName);
		});

		target.classList.add(activeClassName);

		this.updateLineOfBusinessId();

		this.getFilteredData();
	}

	searchClickHandler(event) {
		const searchValue = event.target.value;

		this.state.searchValue = searchValue;

		clearTimeout(this.typingTimeout);

		this.typingTimeout = setTimeout(() => {
			this.getFilteredData();
		}, 1000);
	}

	async getFilteredData()
	{
		const response = await this.repository.getFilteredRepresentatives(
			this.state.regionId,
			this.state.lineOfBusinessId,
			this.state.searchValue
		);

		this.update(response);
	}

	windowResizeHandler(e) {
		window.innerWidth >= 768 ? this.destroyOwl() : this.createOwl();
	}

	updateRegionId() {
		const regionElements = document.getElementsByClassName(
			this.elementClassList.regionFilterItem
		);

		if (!regionElements) {
			return;
		}

		let regionId = 0;
		for (const regionElement of regionElements) {
			if (
				regionElement.classList.contains(this.elementClassList.active)
			) {
				regionId = regionElement.dataset.id;
				break;
			}
		}

		this.state.regionId = regionId;
	}

	updateLineOfBusinessId() {
		const linesOfBusinessElements = document.getElementsByClassName(
			this.linesOFBusiness.linesOFBusinessFilterItem
		);

		if (!linesOfBusinessElements) {
			return;
		}

		let lineOfBusinessId = 0;
		for (const linesOfBusinessElement of linesOfBusinessElements) {
			if (
				linesOfBusinessElement.classList.contains(this.linesOFBusiness.active)
			) {
				lineOfBusinessId = linesOfBusinessElement.dataset.id;
				break;
			}
		}

		this.state.lineOfBusinessId = lineOfBusinessId;
	}

	update(response) {
		const regionTitleElement = document.getElementsByClassName(
			this.elementClassList.regionName
		);
		if (regionTitleElement.length) {
			if(response.data.markup && response.data.region_name == ''){
				regionTitleElement[0].innerHTML = 'All Regions';
			}else{
				regionTitleElement[0].innerHTML = response.data.region_name;
			}
		}

		const representativeFeedListElement = document.getElementsByClassName(
			this.elementClassList.representativeFeedList
		);
		if (representativeFeedListElement.length) {
			representativeFeedListElement[0].innerHTML = response.data.markup;
		}

		// this.addListeners();
	}

	createOwl() {
		const itemsWrapper = document.querySelector(
			'.c-representatives-widget .c-region-filter-list'
		);
		if (!itemsWrapper) {
			return;
		}

		const state = this.state;
		if (state.owl) {
			return;
		}

		itemsWrapper.classList.add('owl-carousel');
		state.owl = jQuery(itemsWrapper).owlCarousel(this.owlConfig);
	}

	destroyOwl() {
		const state = this.state;
		if (!state.owl) {
			return;
		}

		state.owl.trigger('destroy.owl.carousel');
		state.owl = null;

		const itemsWrapper = document.querySelector(
			'.c-representatives-widget .c-region-filter-list'
		);
		if (!itemsWrapper) {
			return;
		}

		itemsWrapper.classList.remove('owl-carousel');
	}
}
